import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const CartPage = () => {
  const { cart, cartTotal, updateItem, removeItem, emptyCart } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div style={{ background: '#111', minHeight: '100vh' }}>
      <Navbar />
      <div style={styles.container}>
        <h1 style={styles.title}>Your Cart</h1>
        {cart.length === 0 ? (
          <div style={styles.empty}>
            <p style={{ color: '#aaa', fontSize: '18px' }}>Your cart is empty</p>
            <button style={styles.shopBtn} onClick={() => navigate('/products')}>Shop Now</button>
          </div>
        ) : (
          <div style={styles.grid}>
            <div style={styles.items}>
              {cart.filter(item => item.product).map(item => (
                <div key={item.product._id} style={styles.item}>
                  <div style={styles.imageBox}>
                    {item.product?.images && item.product.images[0] ? (
                      <img
                        src={item.product.images[0]}
                        alt={item.product.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }}
                      />
                    ) : (
                      <span style={{ color: '#aaa', fontSize: '12px' }}>No Image</span>
                    )}
                  </div>
                  <div style={styles.itemDetails}>
                    <p style={styles.brand}>{item.product?.brand}</p>
                    <h3 style={styles.name}>{item.product?.name}</h3>
                    <p style={styles.size}>{item.product?.size}</p>
                    <p style={styles.price}>
                      ${(item.product?.discountedPrice || item.product?.price)?.toLocaleString()} each
                    </p>
                  </div>
                  <div style={styles.qtyControls}>
                    <button style={styles.qtyBtn} onClick={() => updateItem(item.product._id, item.quantity - 1)}>−</button>
                    <span style={styles.qty}>{item.quantity}</span>
                    <button style={styles.qtyBtn} onClick={() => updateItem(item.product._id, item.quantity + 1)}>+</button>
                  </div>
                  <div style={styles.itemTotal}>
                    <p style={styles.totalPrice}>
                      ${((item.product?.discountedPrice || item.product?.price) * item.quantity)?.toLocaleString()}
                    </p>
                    <button style={styles.removeBtn} onClick={() => removeItem(item.product._id)}>
                      Remove
                    </button>
                  </div>
                </div>
              ))}
              <button style={styles.clearBtn} onClick={emptyCart}>Clear Cart</button>
            </div>

            <div style={styles.summary}>
              <h2 style={styles.summaryTitle}>Order Summary</h2>
              <div style={styles.summaryRow}>
                <span style={{ color: '#aaa' }}>Subtotal</span>
                <span style={{ color: '#fff' }}>$ {cartTotal.toLocaleString()}</span>
              </div>
              <div style={styles.summaryRow}>
                <span style={{ color: '#aaa' }}>Shipping</span>
                <span style={{ color: '#fff' }}>{cartTotal > 15000 ? 'Free' : '$ 500'}</span>
              </div>
              <div style={styles.divider} />
              <div style={styles.summaryRow}>
                <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '18px' }}>Total</span>
                <span style={{ color: '#e63946', fontWeight: 'bold', fontSize: '18px' }}>
                  $ {(cartTotal + (cartTotal > 15000 ? 0 : 500)).toLocaleString()}
                </span>
              </div>
              <button style={styles.checkoutBtn} onClick={() => navigate('/order-request')}>
                📩 Send Order Request
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: { maxWidth: '1100px', margin: '0 auto', padding: '40px 20px' },
  title: { color: '#fff', fontSize: '32px', marginBottom: '32px' },
  empty: { textAlign: 'center', padding: '80px 0' },
  shopBtn: { marginTop: '16px', padding: '12px 32px', background: '#e63946', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 350px', gap: '32px' },
  items: { display: 'flex', flexDirection: 'column', gap: '16px' },
  item: { background: '#1a1a1a', borderRadius: '12px', padding: '16px', display: 'flex', gap: '16px', alignItems: 'center', border: '1px solid #222' },
  imageBox: { width: '80px', height: '80px', background: '#222', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  itemDetails: { flex: 1 },
  brand: { color: '#e63946', fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase' },
  name: { color: '#fff', fontSize: '15px', margin: '4px 0' },
  size: { color: '#aaa', fontSize: '12px' },
  price: { color: '#aaa', fontSize: '13px', marginTop: '4px' },
  qtyControls: { display: 'flex', alignItems: 'center', gap: '10px' },
  qtyBtn: { background: '#222', color: '#fff', border: '1px solid #333', width: '30px', height: '30px', borderRadius: '4px', cursor: 'pointer' },
  qty: { color: '#fff', fontSize: '16px', minWidth: '20px', textAlign: 'center' },
  itemTotal: { textAlign: 'right', minWidth: '100px' },
  totalPrice: { color: '#fff', fontWeight: 'bold', fontSize: '16px' },
  removeBtn: { background: 'none', border: 'none', color: '#e63946', cursor: 'pointer', fontSize: '12px', marginTop: '4px' },
  clearBtn: { background: 'none', border: '1px solid #333', color: '#aaa', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', alignSelf: 'flex-start' },
  summary: { background: '#1a1a1a', borderRadius: '12px', padding: '24px', border: '1px solid #222', height: 'fit-content' },
  summaryTitle: { color: '#fff', fontSize: '20px', marginBottom: '20px' },
  summaryRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '12px' },
  divider: { height: '1px', background: '#333', margin: '16px 0' },
  checkoutBtn: { width: '100%', padding: '14px', background: '#e63946', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer', marginTop: '16px' }
};

export default CartPage;